var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm._m(0)
}
var staticRenderFns = [
  function() {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", [
      _c("div", { staticClass: "row bg-white board-radius py-2 pr-2" }, [
        _c("div", { staticClass: "col-12 col-md-2" }, [
          _c("label", { staticClass: "name-title" }, [
            _vm._v("Leyenda de Tipo de Asistencia:")
          ])
        ]),
        _c("div", { staticClass: "col-12 col-md-10 d-flex px-0" }, [
          _c("div", { staticClass: "content-container col px-0" }, [
            _c("span", { staticClass: "content" }, [
              _c("img", {
                attrs: { src: require("@/assets/img/icon_square-p.svg") }
              }),
              _c("span", [_vm._v("Presencial")])
            ])
          ]),
          _c("div", { staticClass: "content-container col px-0" }, [
            _c("span", { staticClass: "content" }, [
              _c("img", {
                attrs: { src: require("@/assets/img/icon_square-v.svg") }
              }),
              _c("span", [_vm._v("Virtual")])
            ])
          ]),
          _c("div", { staticClass: "content-container col px-0" }, [
            _c("span", { staticClass: "content" }, [
              _c("img", {
                attrs: { src: require("@/assets/img/icon_square-x.svg") }
              }),
              _c("span", [_vm._v("Ausente")])
            ])
          ])
        ])
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }